// packages/web/src/components/PortalFrame.tsx — Core hardening 2026-07-29,
// Item 9: extracted from screens/ReviewerPortal.tsx's own private
// PortalFrame (net-zero behavior change there — same markup, same
// classes). The shared shell EVERY external, unauthenticated grant-portal
// screen uses (currently ReviewerPortal's own review flow, and Item 9's
// new generic RecordGrantPortal) — brand mark, one card, a foot note. No
// account needed, no session, authorized solely by whatever token the
// caller's own route resolved.
import './PortalFrame.css';

export interface PortalFrameProps {
  children: preact.ComponentChildren;
  /** ReviewerPortal's own original copy, kept as the default so its
   * extraction here is a net-zero behavior change — RecordGrantPortal
   * passes its own more generic footer text instead. */
  footNote?: string;
  /** ⚑ THE MASTHEAD, AND IT IS NOT ALWAYS "Vowric".
   *
   * This was hardcoded until 2026-08-26, when a phone walk of the coach
   * surface showed an outside professional a page headed VOWRIC with
   * "CallToWrap" demoted to a footnote — the platform's name over the
   * product's, on the one surface a stranger ever sees.
   *
   * ✅ RULED 2026-08-28 (Huan): "They should not see Vowric anywhere." The
   * reviewer portal — the surface every reviewer a CallToWrap family sends a
   * tape to actually lands on — now carries the DEPLOYMENT's product name,
   * read from the pack's entry config, the same source the tab title and the
   * webmanifest already use. The 'Vowric' default remains for a neutral
   * deployment, where it is the truth rather than a leak.
   *
   * ⚠ PASS `null` WHILE THE NAME IS STILL UNKNOWN, never a guess. The portal
   * screens render before that fetch resolves, and defaulting to "Vowric" for
   * those first frames would flash the wrong company's name at a stranger and
   * then correct itself — which is worse than a masthead that is briefly
   * blank. Null holds the space and says nothing. */
  brand?: string | null;
}

export function PortalFrame({
  children,
  footNote = 'A private review link. No account needed.',
  brand = 'Vowric',
}: PortalFrameProps) {
  return (
    <div class="portal">
      {/* Space is held even when the name is not yet known, so the card does
          not jump when it arrives. */}
      <div class="portal__brand">{brand ?? '\u00a0'}</div>
      <div class="portal__card">{children}</div>
      <div class="portal__foot">{footNote}</div>
    </div>
  );
}
